import { format } from 'date-fns';
import i18n from '../../../../../../../../../../i18n';
import { SESSION_INFORMATION_DATE_FORMAT } from '../../constants';

export const buildPanelGridCommonData = (
  sessionInfo: SessionInformation,
): PanelGridDataItem[] => {
  const {
    endTime,
    lastModified,
    owner,
    sessionId,
    virtualCenter,
    vpnAvailable,
    licenses,
  } = sessionInfo;
  return [
    {
      key: 'owner',
      name: i18n.t('sessions.panels.info.sessionInformation.owner'),
      value: owner,
    },
    {
      key: 'sessionId',
      name: i18n.t('sessions.panels.info.sessionInformation.sessionId'),
      value: sessionId,
    },
    {
      key: 'endTime',
      name: i18n.t('sessions.panels.info.sessionInformation.endTime'),
      value: format(new Date(endTime), SESSION_INFORMATION_DATE_FORMAT),
    },
    {
      key: 'lastModified',
      name: i18n.t('sessions.panels.info.sessionInformation.lastModified'),
      value: format(new Date(lastModified), SESSION_INFORMATION_DATE_FORMAT),
    },
    {
      key: 'vpnAvailable',
      name: i18n.t('sessions.panels.info.sessionInformation.vpnAvailable'),
      value: vpnAvailable ? 'Yes' : 'No',
    },
    {
      key: 'virtualCenter',
      name: i18n.t('sessions.panels.info.sessionInformation.vitualCenter'),
      value: virtualCenter,
    },
    {
      key: 'licenses',
      name: i18n.t('sessions.panels.info.sessionInformation.licenses.title'),
      value: licenses,
    },
  ];
};
